import React from 'react';

import {withWidgetContext} from '../widgetContextProvider';

import AutomatedCallAndBFI from '../../common/automatedCallAndBFI/automatedCallAndBFI';
import ButtonComponent from '../../common/genericComponents/redesign/buttonComponent/buttonComponent';
import CommunicationIcons from '../../../assets/svgComponents/communicationIcons';
import LeadCollectorComponent from './leadCollectorComponent';
import WidgetTitleComponent from './widgetTitleComponent';

import cnameInstanceService from '../../../services/restServices/cnameInstanceService';
import ResourcePermissionsService from '../../../services/resourcePermissionsService';
import utilsService from '../../../services/utilsService';

import VIDABOO_CONSTANTS from '../../../config/consts';

import './widgetVideoComponent.css';

class WidgetVideoComponent extends React.Component {
  constructor(props) {
    super(props);
    this.LOUD_PERMISSONS_DELAY_IN_SEC = 1;
    this.state = {
      peerClientInfo: {},
      showCollectInfo: false,
      isCallAudioOnly: false,
      disableBtn: false,
      disableTimeOut: 0,
      showVideoBtn: false,
    };
    this.loudNotificationTimerId = null;
  }

  componentDidMount() {
    this.updateShowVideoBtn();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.permissionsStatusesObj !== this.props.permissionsStatusesObj &&
      this.props.permissionsStatusesObj
    ) {
      if (this.getIsRequiredPermissionsForCallGranted()) {
        this.props.setShowPermissionsPopup(false);
      }
    }
  }
  componentWillUnmount = () => {
    this.setState({
      disableBtn: false,
    });
    clearTimeout(this.disableBtnTimeout);
    if (this.loudNotificationTimerId) {
      window.clearTimeout(this.loudNotificationTimerId);
    }
  };
  getCurrencySymbol = () => {
    const currency = this.props.sessionTemplate.sessionCurrency;
    return currency === 'USD'
      ? '$'
      : currency === 'EUR'
        ? '€'
        : currency === 'GBP'
          ? '£'
          : '₪';
  };

  updateShowVideoBtn = () => {
    let showVideoBtn = true;
    if (
      this.props.startValueFromQuery ===
        VIDABOO_CONSTANTS.TRIGGER_ACTIONS.AUDIO_CALL ||
      this.props.actionClickData?.etClickType === 'start-audio-call' ||
      this.props.actionClickData?.etConsoltoStart ===
        VIDABOO_CONSTANTS.TRIGGER_ACTIONS.AUDIO_CALL
    ) {
      showVideoBtn = false;
    }
    this.setState({showVideoBtn});
  };
  callbackSuccessInfoSend = (peerClientInfo) => {
    if (peerClientInfo) {
      // if we extracted the peerClientInfo from the customer, we need it in the right structure.
      peerClientInfo = utilsService.getPeerClientInfo(
        this.props.mentor.mentorDto.mentorOwnerId,
        this.props.widgetContext.widgetDto,
      );
    }
    this.setState({peerClientInfo, showCollectInfo: false});
    this.props.startVideochat(peerClientInfo, this.state.isCallAudioOnly);

    this.props.callSendMessageFunc(
      'Videochat call',
      VIDABOO_CONSTANTS.CHAT_SUBTYPES.VIDEOCHAT_MESSAGE,
    );
    this.props.setRefreshShouldCollectUserInfo(true);
  };

  disableBtnTimer = () => {
    this.setState({
      disableBtn: true,
    });
    this.disableBtnTimeout = setTimeout(() => {
      // console.debug('BEEN HERE');
      this.setState({
        disableBtn: false,
      });
    }, 3000);
  };

  initiateVideoCall = async (shouldSchedule) => {
    if (utilsService.isMobileDevice() && !navigator.permissions) {
      //if we open link (like personal page call link) inside the facebook mobile app, then the video/audio call doesn't work properly because navigator is {} in this case. So user needs to open this link in external browser
      alert('For direct calls, please open this link in your default brower.');
      this.setState({showWebCallSpinner: false, showAudioCallSpinner: false});
      return;
    }
    if (
      !VIDABOO_CONSTANTS.TEST_ENV &&
      utilsService.getIsInWidget() === true &&
      document.referrer.search(/^https/) < 0
    ) {
      const domainUrl = await cnameInstanceService.getDomainUrlByWidgetId(
        this.props.widgetContext.widgetDto.widgetId,
      );
      this.setState({showWebCallSpinner: false, showAudioCallSpinner: false});
      const popupLocation = `${domainUrl}/expert/${this.props.mentor.mentorDto.profileName}?start=videocall`;
      //need to popup call window
      this.winPopup = window.open(
        popupLocation,
        'popup',
        'width=1000,height=700,right=10,bottom=150',
      );
      return;
    }
    this.setState({showWebCallSpinner: false, showAudioCallSpinner: false});
    if (
      !this.getIsRequiredPermissionsForCallGranted() ||
      utilsService.getIsInFirefoxBrowser()
    ) {
      const constraints = {
        audio: true,
        video: !this.state.isCallAudioOnly,
      };
      this.props.setShowPermissionsPopup(true);
      if (this.loudNotificationTimerId) {
        window.clearTimeout(this.loudNotificationTimerId);
      }
      this.loudNotificationTimerId = setTimeout(async () => {
        //no need to update state here, will be updated using handlePermissionChange
        try {
          await ResourcePermissionsService.loudGetPermissions(constraints);
          this.props.setShowPermissionsPopup(false);
          this.props.handlePermissionsSuccess(constraints);
          this.startVideoCall(shouldSchedule);
        } catch (error) {
          this.props.setShowPermissionsPopup(true);
        }
      }, this.LOUD_PERMISSONS_DELAY_IN_SEC * 1000);
    } else {
      this.startVideoCall(shouldSchedule);
    }
    // }
  };

  getIsRequiredPermissionsForCallGranted = () => {
    if (this.state.isCallAudioOnly) {
      return (
        this.props.permissionsStatusesObj[
          VIDABOO_CONSTANTS.PERMISSION_TYPES.MICROPHONE
        ] === VIDABOO_CONSTANTS.PERMISSION_STATUS.GRANTED
      );
    } else {
      return (
        this.props.permissionsStatusesObj[
          VIDABOO_CONSTANTS.PERMISSION_TYPES.MICROPHONE
        ] === VIDABOO_CONSTANTS.PERMISSION_STATUS.GRANTED &&
        this.props.permissionsStatusesObj[
          VIDABOO_CONSTANTS.PERMISSION_TYPES.CAMERA
        ] === VIDABOO_CONSTANTS.PERMISSION_STATUS.GRANTED
      );
    }
  };

  startVideoCall = (shouldSchedule) => {
    this.disableBtnTimer();
    if (
      this.props.mentor.mentorDto.appControlDto.requireContactDetailsForCall &&
      !this.props.isDemo
    ) {
      if (utilsService.isLocalStorageSupported()) {
        const peerClientInfo = utilsService.getPeerClientInfo(
          this.props.mentor.mentorDto.mentorOwnerId,
          this.props.widgetContext.widgetDto,
        );
        if (
          peerClientInfo &&
          !utilsService.shouldCollectPeerInfo(
            this.props.mentor.mentorDto.mentorOwnerId,
            this.props.widgetContext.widgetDto,
          )
        ) {
          this.setState({
            peerClientInfo,
            showCollectInfo: false,
          });
          this.props.startVideochat(
            peerClientInfo,
            this.state.isCallAudioOnly,
            shouldSchedule,
          );
          this.props.callSendMessageFunc(
            'Videochat call',
            VIDABOO_CONSTANTS.CHAT_SUBTYPES.VIDEOCHAT_MESSAGE,
          );
        } else {
          this.setState({showCollectInfo: true});
        }
      } else {
        this.setState({showCollectInfo: false});
        this.props.startVideochat(
          {},
          this.state.isCallAudioOnly,
          shouldSchedule,
        );
        this.props.callSendMessageFunc(
          'Videochat call',
          VIDABOO_CONSTANTS.CHAT_SUBTYPES.VIDEOCHAT_MESSAGE,
        );
      }
    } else if (
      !this.props.mentor.mentorDto.appControlDto.requireContactDetailsForCall &&
      !this.props.demo
    ) {
      this.props.callSendMessageFunc(
        'Videochat call',
        VIDABOO_CONSTANTS.CHAT_SUBTYPES.VIDEOCHAT_MESSAGE,
      );
      this.props.startVideochat({}, this.state.isCallAudioOnly, shouldSchedule);
    } else {
      this.setState({showCollectInfo: false});
    }
  };

  connectAudioOnlyCall = (shouldSchedule) => {
    this.setState(
      {
        isCallAudioOnly: true,
        showAudioCallSpinner: true,
      },
      () => {
        this.props.setIsCallAudioOnly(true);
        this.initiateVideoCall(shouldSchedule);
      },
    );
  };

  connectVideoCall = (shouldSchedule) => {
    this.setState(
      {
        isCallAudioOnly: false,
        showWebCallSpinner: true,
      },
      () => {
        this.props.setIsCallAudioOnly(false);
        this.initiateVideoCall(shouldSchedule);
      },
    );
  };

  render() {
    const {
      disableBtn,
      showCollectInfo,
      showAudioCallSpinner,
      showWebCallSpinner,
    } = this.state;
    const {
      isAutomatedCallHandled,
      isClearedManually,
      isDemo,
      isPersonalPage,
      isWithButton,
      postCallFail,
      showNotificationPopupForWait,
      actionClickData,
      bfi,
      callState,
      mentor,
      callSendMessageFunc,
      onFooterOptionSelected,
      resetActionClickData,
      sessionTemplate,
      startValueFromQuery,
      clearAutomatedCallLoop,
      sendStartChatGA,
      setIsAutomatedCallHandled,
    } = this.props;
    let sessionMode = sessionTemplate?.sessionMode;
    let videoBtn = false;
    let audioBtn = false;
    if (sessionMode) {
      if (sessionMode === VIDABOO_CONSTANTS.SESSION_MODES.AUDIO_VIDEO) {
        videoBtn = true;
        audioBtn = true;
      }
      if (sessionMode === VIDABOO_CONSTANTS.SESSION_MODES.AUDIO_ONLY) {
        audioBtn = true;
      } else if (sessionMode === VIDABOO_CONSTANTS.SESSION_MODES.VIDEO_ONLY) {
        videoBtn = true;
      }
    }

    return (
      <div
        className={`${
          isPersonalPage
            ? 'et-personal-page-right-content-wrap'
            : 'et-widget-body-content-wrap'
        }
        ${isPersonalPage && showCollectInfo ? 'et-pp-right-content-wrap-no-border ' : ''}`}>
        {!isDemo && (
          <AutomatedCallAndBFI
            isAutomatedCallHandled={isAutomatedCallHandled}
            isClearedManually={isClearedManually}
            isPersonalPage={isPersonalPage}
            isWithButton={isWithButton}
            postCallFail={postCallFail}
            showNotificationPopupForWait={showNotificationPopupForWait}
            actionClickData={actionClickData}
            bfi={bfi}
            extendedMentorDto={mentor}
            sessionTemplateDto={sessionTemplate}
            startValueFromQuery={startValueFromQuery}
            clearAutomatedCallLoop={clearAutomatedCallLoop}
            connectAudioOnlyCall={this.connectAudioOnlyCall}
            connectVideoCall={this.connectVideoCall}
            resetActionClickData={resetActionClickData}
            setIsAutomatedCallHandled={setIsAutomatedCallHandled}
            sendStartChatGA={sendStartChatGA}
            onFooterOptionSelected={onFooterOptionSelected}
          />
        )}
        <div
          className={`et-widget-video-container ${isPersonalPage && !showCollectInfo ? 'et-pp-widget-video-container' : ''}`}>
          {!showCollectInfo && (
            <div className="et-videocall-content-wrap">
              <div className="et-vc-title-session-cost-wrap">
                <div className="et-vc-title">
                  {mentor.mentorDto.appControlDto.widgetEditableTexts &&
                  mentor.mentorDto.appControlDto.widgetEditableTexts[
                    VIDABOO_CONSTANTS.WIDGET_APP_TYPES.WEBCALL
                  ]
                    ? mentor.mentorDto.appControlDto.widgetEditableTexts[
                        VIDABOO_CONSTANTS.WIDGET_APP_TYPES.WEBCALL
                      ]
                    : 'Let’s Talk'}
                </div>
                {sessionTemplate.sessionCost > 0 && (
                  <div className="et-vc-video-widget-title-wrap">
                    <WidgetTitleComponent
                      title={`for ${this.getCurrencySymbol()}${sessionTemplate.sessionCost}`}
                    />
                  </div>
                )}
              </div>

              {callState === VIDABOO_CONSTANTS.VIDEO_CALL_STATE.INIT && (
                <div
                  className={`et-videocall-btns-wrap ${sessionTemplate.sessionCost > 0 ? 'et-videocall-btns-wrap-less-margin' : ''}`}>
                  {videoBtn && this.state.showVideoBtn && (
                    <div className="et-vc-button-container">
                      <ButtonComponent
                        showSpinner={showWebCallSpinner}
                        text={
                          mentor.mentorDto.appControlDto.widgetEditableTexts &&
                          mentor.mentorDto.appControlDto.widgetEditableTexts[
                            VIDABOO_CONSTANTS.WIDGET_APP_CTA_TYPES_BTN_TEXT
                              .WEBCALL
                          ]
                            ? mentor.mentorDto.appControlDto
                                .widgetEditableTexts[
                                VIDABOO_CONSTANTS.WIDGET_APP_CTA_TYPES_BTN_TEXT
                                  .WEBCALL
                              ]
                            : 'Start Video Call'
                        }
                        isDisabled={
                          disableBtn ||
                          showWebCallSpinner ||
                          showAudioCallSpinner
                        }
                        onClick={() => {
                          if (!isDemo) {
                            this.connectVideoCall();
                          }
                        }}
                        image={
                          <CommunicationIcons.VideoIcon
                            showNewUI={!isPersonalPage}
                            fillColor={
                              'var(--et-mentor-cta-primary-btn-text-color)'
                            }
                          />
                        }
                      />
                    </div>
                  )}
                  {audioBtn && (
                    <div className="et-vc-button-container">
                      <ButtonComponent
                        showSpinner={showAudioCallSpinner}
                        text={
                          mentor.mentorDto.appControlDto.widgetEditableTexts &&
                          mentor.mentorDto.appControlDto.widgetEditableTexts[
                            VIDABOO_CONSTANTS.WIDGET_APP_CTA_TYPES_BTN_TEXT
                              .AUDIO_WEBCALL
                          ]
                            ? mentor.mentorDto.appControlDto
                                .widgetEditableTexts[
                                VIDABOO_CONSTANTS.WIDGET_APP_CTA_TYPES_BTN_TEXT
                                  .AUDIO_WEBCALL
                              ]
                            : 'Start Voice Call'
                        }
                        type={isPersonalPage ? 'primary-outlined' : 'other'}
                        isDisabled={
                          disableBtn ||
                          showWebCallSpinner ||
                          showAudioCallSpinner
                        }
                        onClick={() => {
                          if (!isDemo) {
                            this.connectAudioOnlyCall();
                          }
                        }}
                        image={
                          <CommunicationIcons.PhoneIcon
                            showNewUI={!isPersonalPage}
                            fillColor={
                              isPersonalPage
                                ? 'var(--et-mentor-cta-btn-primary-background-color-fc)'
                                : 'var(--et-mentor-primary-text-color)'
                            }
                          />
                        }
                      />
                    </div>
                  )}
                </div>
              )}
            </div>
          )}
          {mentor.mentorDto?.appControlDto?.requireContactDetailsForCall &&
            showCollectInfo && (
              <div className="et-vc-lc-wrap">
                <LeadCollectorComponent
                  isDemo={isDemo}
                  isPersonalPage={isPersonalPage}
                  callSendMessageFunc={callSendMessageFunc}
                  mentor={mentor}
                  selectedWidgetAppType={
                    VIDABOO_CONSTANTS.WIDGET_APP_TYPES.WEBCALL
                  }
                  callbackSuccessInfoSend={this.callbackSuccessInfoSend}
                  sendMailToMentor={true}
                />
              </div>
            )}
        </div>
      </div>
    );
  }
}

export default withWidgetContext(WidgetVideoComponent);
